import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GpsOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gps_off"}/>
}
